import React from 'react';

interface IMastercardIconProps {
	className?: string;
}

export const MastercardIcon = ({ className }: IMastercardIconProps) => (
	<svg aria-hidden="true" width="44" height="32" viewBox="0 0 44 32" fill="none" className={className}>
		<rect x="0.5" y="0.5" width="43" height="31" rx="3.5" stroke="#EBEBEB" />
		<path d="M25.1444 21.5031H18.8555V10.4965H25.1444V21.5031Z" fill="#FF5F00" />
		<path
			d="M19.2547 16C19.2547 13.7672 20.3281 11.7784 21.9997 10.4967C20.7773 9.55941 19.2346 9 17.5579 9C13.5887 9 10.3711 12.134 10.3711 16C10.3711 19.866 13.5887 23 17.5579 23C19.2346 23 20.7773 22.4406 21.9997 21.5033C20.3281 20.2216 19.2547 18.2328 19.2547 16Z"
			fill="#EB001B"
		/>
		<path
			d="M33.6291 16C33.6291 19.866 30.4115 23 26.4423 23C24.7656 23 23.2229 22.4406 22 21.5033C23.6721 20.2216 24.7455 18.2328 24.7455 16C24.7455 13.7672 23.6721 11.7784 22 10.4967C23.2229 9.55941 24.7656 9 26.4423 9C30.4115 9 33.6291 12.134 33.6291 16Z"
			fill="#F79E1B"
		/>
	</svg>
);
